import { AppBundle } from 'api/optimalprint-sdk.d';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import {
  filterProducts,
  getSpecifiedAttributes,
  removeAttribute,
  setAttributeValue,
} from 'utils/StudioSearchProductPage/attributeUtils';
import { setCurrentProductAction, setProductIdAction, setSelectedBundleProductsAction } from '../slice';

type Product = AppBundle.Api.Entity.App.V1.AbstractProduct.IProductItem;

const changeAttributeOperation =
  (typeName: string, value: string, defaultProductId: number) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { currentProduct, selectedAbstractProduct } = store.publicAssetProduct;

    const productPageSelectors = selectedAbstractProduct?.productPageSelectors || [];
    const productPageAttributeList = productPageSelectors.map((selector) => selector.typeName);
    const allProductAttributes = currentProduct?.attributes || [];

    const importantProductAttributes = setAttributeValue(
      getSpecifiedAttributes(productPageAttributeList, allProductAttributes),
      typeName,
      value,
    );
    const allProducts = selectedAbstractProduct?.products || [];
    let bestMatchingProducts = filterProducts(allProducts as Product[], importantProductAttributes);

    // if not matching products found, select matching product removed attributes one by one, except the one which just was set
    if (!bestMatchingProducts.length) {
      const attributesToRemove = importantProductAttributes.filter((attr) => attr.typeName !== typeName);
      attributesToRemove.some((attrToRemove) => {
        bestMatchingProducts = filterProducts(
          allProducts as Product[],
          removeAttribute(importantProductAttributes, attrToRemove.typeName),
        );
        return bestMatchingProducts.length > 0;
      });
      // if not matching products found, select products only by just modified attribute
      // simplified version
      // importantProductAttributes = setAttributeValue([], typeName, value);
      // bestMatchingProducts = filterProducts(allProducts as any[], importantProductAttributes);
    }
    const pId = bestMatchingProducts.length ? bestMatchingProducts[0].productId : defaultProductId;
    dispatch(setProductIdAction(pId));
    const currProd = selectedAbstractProduct?.products?.find((p) => p.productId === pId);
    dispatch(setCurrentProductAction(currProd));
    dispatch(setSelectedBundleProductsAction([]));
  };

export default changeAttributeOperation;
